import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ModalSheetPayloadProps {
  content: string;
  actionLabelCancel: string;
}

export interface ModalSheetProps {
  payload: ModalSheetPayloadProps;
  type?: 'annex';
}

interface ModalSheetState {
  type: null | string;
  props: ModalSheetPayloadProps;
}

export const modalSheetSlice = createSlice({
  name: 'modalSheet',
  initialState: {
    // Required for dispatcher to know what is currently requested modal.
    type: null,
    // Any props that are blindly passed to the Modal content component.
    // Each ModalSheet type needs different props, including the custom one you create.
    props: {},
  } as ModalSheetState,
  reducers: {
    setModalSheetProps: (draftState, { payload }: PayloadAction<ModalSheetProps>) => {
      const newState = { ...draftState };
      newState.type = payload.type || 'annex';
      newState.props = { ...payload.payload };
      return newState;
    },
    setModalSheetHidden: () => ({ type: null, props: {} as ModalSheetPayloadProps }),
  },
});

export const { setModalSheetProps, setModalSheetHidden } = modalSheetSlice.actions;
